function _instanceof(left, right) {
    "@swc/helpers - instanceof";
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
/**
    Finds the closest numeric value in an array.
    @param n The number value to use when searching the array.
    @param arr The array of values to test against.
*/ export default function(n) {
    var arr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    if (!arr || !_instanceof(arr, Array) || !arr.length) return undefined;
    return arr.reduce(function(prev, curr) {
        return Math.abs(curr - n) < Math.abs(prev - n) ? curr : prev;
    });
}

//# sourceMappingURL=closest.js.map